import { createContext } from "react";

const MainContext = createContext();

export { MainContext };
